import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { WhatsAppFab } from '../WhatsAppFab';
import { Toaster } from '../ui/sonner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#F7F6F3]">
      <Header />
      <main className="pb-20 md:pb-0">
        {children}
      </main>
      <BottomNav />
      <WhatsAppFab />
      <div className="design-stamp">Design by Culto</div>
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: '#0F172A',
            color: '#fff',
            border: 'none',
          },
        }}
      />
    </div>
  );
};
